import {PageTitle, OAuthLogin, IntlText, GenericObject, InternalLink, AppName, P} from 'components';
import {PrivacyModal, TermsModal} from 'modals';
import type {UserCredential, UserInfo} from 'firebase/auth';
import Divider from '@mui/material/Divider';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { ROUTES } from 'routes';

interface Props {
  onSuccess: (result: UserCredential | UserInfo) => void;
  state?: GenericObject | null; 
  providers?: string[];
}

export const LoginForm = ({onSuccess = () => {}, state = null, providers }: Props) => (
  <>
    <PageTitle textAlign='center'>
      <IntlText id="signin"/>
    </PageTitle>
    {state?.message && (
      <Box mb={2}>
        <Alert severity="info">{state.message}</Alert>
      </Box>
    )}
    <OAuthLogin onSuccess={onSuccess} providers={providers}/>
    <Box mt={3} textAlign='center'>
      Don't have an account? <InternalLink color="primary" to={ROUTES.signup}>Join <AppName/>!</InternalLink>
    </Box>
    <Divider sx={{ mt: 2 }}/>
    <P textAlign='justify' fontSize='small'>
      <IntlText id="register_text" values={{ privacy: <PrivacyModal/>, terms: <TermsModal/>}}/>
    </P>
  </>
);
